import React from 'react';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';
import { IAssignmentDetails } from '@/components/staffer/Grading/types';
import cn from '@/utils/cn';
import BottomRowFilters from './BottomRowFilters';
import TopRowFilters from './TopRowFilters';
import TitleRow from './TitleRow';
import StatusBox from '../StatusBox';
import QuestionNavigator from './QuestionNavigator';
import GameStatusBox from '../StatusBox/GameStatusBox';

const StatusContent = ({ isGame }: { isGame?: boolean }) => {
  const { isQuestionMode } = useGradingStore();

  if (isQuestionMode) return <QuestionNavigator />;
  if (isGame) return <GameStatusBox />;

  return <StatusBox />;
};

const HeaderWithFilters = () => {
  const { assignment, isTeacher, questionAnswers } = useGradingStore();

  const {
    assignment_details: assignmentDetails = {} as IAssignmentDetails,
  } = assignment || {};

  if (!assignment) return null;

  const isGame = ['Challenge', 'Game'].includes(assignmentDetails.exercise_type);
  const greyBorder = 'tw-box-border tw-border tw-border-solid tw-border-med-grey tw-rounded-lg';

  const renderFiltersBox = () => (
    <div className={`tw-flex tw-flex-row tw-basis-2/3 ${greyBorder} tw-py-2.5 tw-px-4`}>
      <div className="tw-flex-start tw-font-bold tw-text-base tw-pr-6">
        Filters:
      </div>
      <div className="tw-w-full">
        <div className="tw-flex tw-gap-3 tw-mb-2">
          <TopRowFilters classrooms={assignment.classrooms} />
        </div>
        <div className="tw-flex tw-gap-3">
          <BottomRowFilters />
        </div>
      </div>
    </div>
  );

  const showFilters = isTeacher && !isGame;

  return (
    <div className={`tw-bg-[#f9f9f9] ${greyBorder} tw-p-5`}>
      <TitleRow
        assignmentName={assignmentDetails.title}
        dueDatetime={assignment.due_datetime}
        lessonLocation={assignment.assignment_location}
      />

      <div className="tw-flex tw-gap-2.5 tw-pt-4">
        {showFilters && renderFiltersBox()}
        <div
          className={cn(
            greyBorder,
            'tw-py-2.5 tw-px-4',
            {
              'tw-basis-1/3': showFilters,
              'tw-basis-full': !showFilters,
              'tw-hidden': !questionAnswers,
            },
          )}
        >
          <StatusContent isGame={isGame} />
        </div>
      </div>
    </div>
  );
};

export default HeaderWithFilters;
